<template>
  <div>
    <div class="workOrder_info">
      <div class="left">
        <p>单号: {{ info.procurementNum }}</p>
        <p>申请人: {{ info.receive }}</p>
      </div>
      <div class="center" v-show="info.state == 5 ? true : false">
        <el-steps :active="5" align-center>
          <el-step title="申请" :description="info.receiveTime" icon="el-icon-edit-outline"></el-step>
          <el-step title="审核" :description="info.examineTime" icon="el-icon-coordinate"></el-step>
          <el-step title="采购" :description="info.procurementTime" icon="el-icon-shopping-cart-full"></el-step>
          <el-step title="发货" :description="info.sendGoodsTime" icon="el-icon-truck"></el-step>
          <el-step title="收货" :description="info.finishTime" icon="el-icon-circle-check"></el-step>
        </el-steps>
      </div>
      <div class="right" style="margin-right: 10px">
        <h1 class="common_color1" v-if="info.state === 1">已申请</h1>
        <h1 class="common_color2" v-if="info.state === 2">已审核</h1>
        <h1 class="common_color2" v-if="info.state === 3">采购中</h1>
        <h1 class="common_color2" v-if="info.state === 4">派送中...</h1>
        <h1 class="common_color3" v-if="info.state === 5">
          {{ handlingTime2 }}
        </h1>
        <h1 class="common_color4" v-if="info.state === 6">审核未通过</h1>
        <h1 class="common_color4" v-if="info.state === 7">拒绝收货</h1>
      </div>
    </div>
    <el-divider class="divider"></el-divider>
    <div class="bottom">
      <div class="Bleft">
        <Form ref="formDynamic" :model="formDynamic" :label-width="80">
          <List border size="small">
            <ListItem>
              <Col span="3"> 医院/申请人:</Col>
              <Col span="19">{{ info.customerName }}/{{ info.receive }}</Col>
            </ListItem>
            <ListItem v-if="shiyou">
              <Col span="3">事由:</Col>
              <Col span="19">{{ shiyou }}</Col>
            </ListItem>
            <ListItem>
              <Col span="4">期望交付日期:</Col>
              <Col span="18">{{ jiaofuData }}</Col>
            </ListItem>
            <ListItem>
              <Col span="3">收货信息:</Col>
              <Col span="19">{{ shouhuoInfo }}</Col>
            </ListItem>
          </List>
          <!-- 表格 -->
          <h4 style="margin: 10px 0">明细:</h4>
          <Row :gutter="5">
            <Col span="24">
            <Table :columns="tableCols1" :data="data1" :table="table" :border="table.border" :stripe="table.stripe"
              :header="table.header" :footer="table.footer" :columns-list="tableCols1">
            </Table>
            </Col>
          </Row>
          <Row :gutter="5">
            <Col span="19" v-show="customerId == 0 ? true : false">
            <h3 class="zong">优惠后总价:{{ endTotalPrice }}元</h3>
            </Col>
            <Col :span="customerId == 0 ? '5' : '24'">
            <h3 class="zong">总价:{{ zongjia }}元</h3>
            </Col>
          </Row>
          <h4 v-show="customerId == 0 ? true : false" style="margin: 10px 0">
            采购合同:
          </h4>
          <Row :gutter="5" v-show="customerId == 0 ? true : false">
            <Col span="24">
            <Table :columns="tableCols2" :data="data2" :table="table" :border="table.border" :stripe="table.stripe"
              :header="table.header" :footer="table.footer" :columns-list="tableCols2">
            </Table>
            </Col>
          </Row>
        </Form>
      </div>
      <div class="Bright">
        <el-timeline>
          <!-- 已申请 -->
          <div v-if="info.state === 1">
            <el-timeline-item :timestamp="info.receiveTime" placement="top" size="large" color="#11d169"
              icon="el-icon-circle-check">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.receiveImg
                      ? info.receiveImg.includes('http')
                        ? info.receiveImg
                        : IMAGE_HOST + info.receiveImg
                      : info.receiveImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.receive }}提交申请</h3>
                    <p>申请客户: {{ info.customerName }}</p>
                    <p v-show="info.receiveOpinion ? true : false">
                      申请意见: {{ info.receiveOpinion }}
                    </p>
                    <p>申请时间: {{ info.receiveTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.examineBy == null ? false : true">
                      指派审核人: {{ info.examineBy }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </div>

          <!-- 已审核 examineId  procurementId-->
          <div v-if="info.state === 2">
            <el-timeline-item :timestamp="info.examineTime" placement="top" size="large" color="#11d169"
              icon="el-icon-circle-check">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.examineImg
                      ? info.examineImg.includes('http')
                        ? info.examineImg
                        : IMAGE_HOST + info.examineImg
                      : info.examineImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.examineBy }}审核通过</h3>
                    <p v-show="info.approvalOpinions ? true : false">
                      审核意见: {{ info.approvalOpinions }}
                    </p>
                    <p>审核时间: {{ info.examineTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.procurementBy == null ? false : true">
                      指派采购人: {{ info.procurementBy }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="info.receiveTime" placement="top" size="large" color="#11d169"
              icon="el-icon-circle-check">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.receiveImg
                      ? info.receiveImg.includes('http')
                        ? info.receiveImg
                        : IMAGE_HOST + info.receiveImg
                      : info.receiveImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.receive }}提交申请</h3>
                    <p>申请客户: {{ info.customerName }}</p>
                    <p v-show="info.receiveOpinion ? true : false">
                      申请意见: {{ info.receiveOpinion }}
                    </p>
                    <p>申请时间: {{ info.receiveTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.examineBy == null ? false : true">
                      指派审核人: {{ info.examineBy }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </div>

          <!-- 已采购 -->
          <div v-if="info.state === 3">
            <el-timeline-item :timestamp="info.procurementTime" placement="top" size="large" color="#fe7a24"
              icon="el-icon-more-outline">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.procurementImg
                      ? info.procurementImg.includes('http')
                        ? info.procurementImg
                        : IMAGE_HOST + info.procurementImg
                      : info.procurementImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.procurementBy }}采购中...</h3>
                    <p v-show="info.procurementOpinions ? true : false">
                      采购意见: {{ info.procurementOpinions }}
                    </p>
                    <p>采购时间: {{ info.procurementTime }}</p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="info.examineTime" placement="top" size="large" color="#11d169"
              icon="el-icon-circle-check">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.examineImg
                      ? info.examineImg.includes('http')
                        ? info.examineImg
                        : IMAGE_HOST + info.examineImg
                      : info.examineImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.examineBy }}审核通过</h3>
                    <p v-show="info.approvalOpinions ? true : false">
                      审核意见: {{ info.approvalOpinions }}
                    </p>
                    <p>审核时间: {{ info.examineTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.procurementBy == null ? false : true">
                      指派采购人: {{ info.procurementBy }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="info.receiveTime" placement="top" size="large" color="#11d169"
              icon="el-icon-circle-check">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.receiveImg
                      ? info.receiveImg.includes('http')
                        ? info.receiveImg
                        : IMAGE_HOST + info.receiveImg
                      : info.receiveImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.receive }}提交申请</h3>
                    <p>申请客户: {{ info.customerName }}</p>
                    <p v-show="info.receiveOpinion ? true : false">
                      申请意见: {{ info.receiveOpinion }}
                    </p>
                    <p>申请时间: {{ info.receiveTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.examineBy == null ? false : true">
                      指派审核人: {{ info.examineBy }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </div>

          <!-- 已发货 -->
          <div v-if="info.state === 4">
            <el-timeline-item :timestamp="info.sendGoodsTime" placement="top" size="large" color="#fe7a24"
              icon="el-icon-more-outline">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.procurementImg
                      ? info.procurementImg.includes('http')
                        ? info.procurementImg
                        : IMAGE_HOST + info.procurementImg
                      : info.procurementImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>派送中...</h3>
                    <p>物流单号: {{ TrackingNum }}</p>
                    <p v-show="info.shippingOpinion ? true : false">
                      发货意见: {{ info.shippingOpinion }}
                    </p>
                    <p>发货时间: {{ info.sendGoodsTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.sendGoodsBy == null ? false : true">
                      发货人: {{ info.sendGoodsBy }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="info.procurementTime" placement="top" size="large" color="#11d169"
              icon="el-icon-circle-check">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.procurementImg
                      ? info.procurementImg.includes('http')
                        ? info.procurementImg
                        : IMAGE_HOST + info.procurementImg
                      : info.procurementImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.procurementBy }}采购完成</h3>
                    <p v-show="info.procurementOpinions ? true : false">
                      采购意见: {{ info.procurementOpinions }}
                    </p>
                    <p>采购时间: {{ info.procurementTime }}</p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="info.examineTime" placement="top" size="large" color="#11d169"
              icon="el-icon-circle-check">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.examineImg
                      ? info.examineImg.includes('http')
                        ? info.examineImg
                        : IMAGE_HOST + info.examineImg
                      : info.examineImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.examineBy }}审核通过</h3>
                    <p v-show="info.approvalOpinions ? true : false">
                      审核意见: {{ info.approvalOpinions }}
                    </p>
                    <p>审核时间: {{ info.examineTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.procurementBy == null ? false : true">
                      指派采购人: {{ info.procurementBy }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="info.receiveTime" placement="top" size="large" color="#11d169"
              icon="el-icon-circle-check">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.receiveImg
                      ? info.receiveImg.includes('http')
                        ? info.receiveImg
                        : IMAGE_HOST + info.receiveImg
                      : info.receiveImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.receive }}提交申请</h3>
                    <p>申请客户: {{ info.customerName }}</p>
                    <p v-show="info.receiveOpinion ? true : false">
                      申请意见: {{ info.receiveOpinion }}
                    </p>
                    <p>申请时间: {{ info.receiveTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.examineBy == null ? false : true">
                      指派审核人: {{ info.examineBy }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </div>

          <!-- 已收货 -->
          <div v-if="info.state === 5">
            <el-timeline-item :timestamp="info.finishTime" placement="top" size="large" color="#11d169"
              icon="el-icon-circle-check">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.receiveImg
                      ? info.receiveImg.includes('http')
                        ? info.receiveImg
                        : IMAGE_HOST + info.receiveImg
                      : info.receiveImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.receive }}已收货</h3>
                    <p v-show="info.takeGoodsOption ? true : false">
                      收货意见: {{ info.takeGoodsOption }}
                    </p>
                    <p>收货时间: {{ info.finishTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.receive == null ? false : true">
                      收货人: {{ info.receive }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="info.sendGoodsTime" placement="top" size="large" color="#11d169"
              icon="el-icon-circle-check">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.procurementImg
                      ? info.procurementImg.includes('http')
                        ? info.procurementImg
                        : IMAGE_HOST + info.procurementImg
                      : info.procurementImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>派送完成</h3>
                    <p>物流单号: {{ TrackingNum }}</p>
                    <p v-show="info.shippingOpinion ? true : false">
                      发货意见: {{ info.shippingOpinion }}
                    </p>
                    <p>发货时间: {{ info.sendGoodsTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.sendGoodsBy == null ? false : true">
                      发货人: {{ info.sendGoodsBy }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="info.procurementTime" placement="top" size="large" color="#11d169"
              icon="el-icon-circle-check">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.procurementImg
                      ? info.procurementImg.includes('http')
                        ? info.procurementImg
                        : IMAGE_HOST + info.procurementImg
                      : info.procurementImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.procurementBy }}采购完成</h3>
                    <p v-show="info.procurementOpinions ? true : false">
                      采购意见: {{ info.procurementOpinions }}
                    </p>
                    <p>采购时间: {{ info.procurementTime }}</p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="info.examineTime" placement="top" size="large" color="#11d169"
              icon="el-icon-circle-check">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.examineImg
                      ? info.examineImg.includes('http')
                        ? info.examineImg
                        : IMAGE_HOST + info.examineImg
                      : info.examineImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.examineBy }}审核通过</h3>
                    <p v-show="info.approvalOpinions ? true : false">
                      审核意见: {{ info.approvalOpinions }}
                    </p>
                    <p>审核时间: {{ info.examineTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.procurementBy == null ? false : true">
                      指派采购人: {{ info.procurementBy }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="info.receiveTime" placement="top" size="large" color="#11d169"
              icon="el-icon-circle-check">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.receiveImg
                      ? info.receiveImg.includes('http')
                        ? info.receiveImg
                        : IMAGE_HOST + info.receiveImg
                      : info.receiveImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.receive }}提交申请</h3>
                    <p>申请客户: {{ info.customerName }}</p>
                    <p v-show="info.receiveOpinion ? true : false">
                      申请意见: {{ info.receiveOpinion }}
                    </p>
                    <p>申请时间: {{ info.receiveTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.examineBy == null ? false : true">
                      指派审核人: {{ info.examineBy }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </div>

          <!-- 拒绝审核 -->
          <div v-if="info.state === 6">
            <el-timeline-item :timestamp="info.examineTime" placement="top" size="large" color="red"
              icon="el-icon-circle-close">
              <el-card>
                <h3 style="color: red">{{ info.examineBy }}审核未通过</h3>
                <p>原因: {{ info.rejectReason }}</p>
              </el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="info.receiveTime" placement="top" size="large" color="#11d169"
              icon="el-icon-circle-check">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.receiveImg
                      ? info.receiveImg.includes('http')
                        ? info.receiveImg
                        : IMAGE_HOST + info.receiveImg
                      : info.receiveImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.receive }}提交申请</h3>
                    <p>申请客户: {{ info.customerName }}</p>
                    <p>申请时间: {{ info.receiveTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.examineBy == null ? false : true">
                      指派审核人: {{ info.examineBy }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </div>

          <!-- 拒绝收货 -->
          <div v-if="info.state === 7">
            <el-timeline-item :timestamp="info.finishTime" placement="top" size="large" color="red"
              icon="el-icon-circle-close">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.receiveImg
                      ? info.receiveImg.includes('http')
                        ? info.receiveImg
                        : IMAGE_HOST + info.receiveImg
                      : info.receiveImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3 style="color: red">拒绝收货</h3>
                    <p v-show="info.returnRemark ? true : false">
                      原因: {{ info.returnRemark }}
                    </p>
                    <p>提交时间: {{ info.updateTime }}</p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="info.sendGoodsTime" placement="top" size="large" color="#11d169"
              icon="el-icon-circle-check">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.procurementImg
                      ? info.procurementImg.includes('http')
                        ? info.procurementImg
                        : IMAGE_HOST + info.procurementImg
                      : info.procurementImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>派送完成</h3>
                    <p>物流单号: {{ TrackingNum }}</p>
                    <p v-show="info.shippingOpinion ? true : false">
                      发货意见: {{ info.shippingOpinion }}
                    </p>
                    <p>发货时间: {{ info.sendGoodsTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.sendGoodsBy == null ? false : true">
                      发货人: {{ info.sendGoodsBy }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="info.procurementTime" placement="top" size="large" color="#11d169"
              icon="el-icon-circle-check">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.procurementImg
                      ? info.procurementImg.includes('http')
                        ? info.procurementImg
                        : IMAGE_HOST + info.procurementImg
                      : info.procurementImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.procurementBy }}采购完成</h3>
                    <p v-show="info.procurementOpinions ? true : false">
                      采购意见: {{ info.procurementOpinions }}
                    </p>
                    <p>采购时间: {{ info.procurementTime }}</p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="info.examineTime" placement="top" size="large" color="#11d169"
              icon="el-icon-circle-check">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.examineImg
                      ? info.examineImg.includes('http')
                        ? info.examineImg
                        : IMAGE_HOST + info.examineImg
                      : info.examineImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.examineBy }}审核通过</h3>
                    <p v-show="info.approvalOpinions ? true : false">
                      审核意见: {{ info.approvalOpinions }}
                    </p>
                    <p>审核时间: {{ info.examineTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.procurementBy == null ? false : true">
                      指派采购人: {{ info.procurementBy }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
            <el-timeline-item :timestamp="info.receiveTime" placement="top" size="large" color="#11d169"
              icon="el-icon-circle-check">
              <el-card>
                <div style="display: flex">
                  <el-avatar style="margin-right: 10px" shape="circle" :size="50" :src="info.receiveImg
                      ? info.receiveImg.includes('http')
                        ? info.receiveImg
                        : IMAGE_HOST + info.receiveImg
                      : info.receiveImg
                    " @error="errorHandler">
                    <img src="../../assets/img/useravatar.jpg" />
                  </el-avatar>
                  <div>
                    <h3>{{ info.receive }}提交申请</h3>
                    <p>申请客户: {{ info.customerName }}</p>
                    <p v-show="info.receiveOpinion ? true : false">
                      申请意见: {{ info.receiveOpinion }}
                    </p>
                    <p>申请时间: {{ info.receiveTime }}</p>
                    <p style="height: 10px"></p>
                    <p v-show="info.examineBy == null ? false : true">
                      指派审核人: {{ info.examineBy }}
                    </p>
                  </div>
                </div>
              </el-card>
            </el-timeline-item>
          </div>
        </el-timeline>
      </div>
    </div>
  </div>
</template>
<script>
import { IMAGE_HOST } from "@/../config";
export default {
  name: "orderInfo",
  components: {},
  props: {
    kv: null,
    workId: {
      type: String,
      value: "",
    },
  },
  watch: {
    kv(v) { },
  },
  data() {
    return {
      customerId: window.localStorage.getItem("customerId"),
      IMAGE_HOST: IMAGE_HOST,
      TrackingNum: 0,
      zongjia: 0,
      endTotalPrice: 0,
      shiyou: "",
      jiaofuData: "",
      shouhuoInfo: "",
      data: 0,
      text: "",
      mname: "inventory",
      info: {},
      list: [],
      id: "",
      data1: [],
      data2: [],
      maintainerName: "",
      responseTime: "", //响应时间
      handlingTime: "", //处理时间
      handlingTime2: "", //总处理时间
      table: {
        mname: "consumables",
        key: "id",
        url: {},
        output: false,
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      tableCols1: [
        {
          title: "序号",
          type: "index",
          width: 65,
          align: "center",
        },
        {
          title: "货物信息",
          width: 400,
          align: "center",
          render: (h, p) => {
            return h(
              "div",
              {
                style: {
                  height: "80px",
                  display: "flex",
                  justifyContent: "flex-start",
                },
              },
              [
                h("img", {
                  style: {
                    width: "60px",
                    height: "60px",
                    margin: "10px",
                  },
                  attrs: { src: IMAGE_HOST + p.row.consumableImgUrl },
                }),
                h("div", [
                  h(
                    "p",
                    {
                      style: {
                        marginTop: "10px",
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      },
                      domProps: {
                        title: p.row.brand + p.row.name,
                      },
                    },
                    p.row.brand + p.row.name
                  ),
                  h(
                    "p",
                    {
                      style: {
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: p.row.model == null ? "none" : "block",
                      },
                      domProps: {
                        title: "型号:" + p.row.model,
                      },
                    },
                    "型  号: " + p.row.model
                  ),
                  h(
                    "p",
                    {
                      style: {
                        width: "250px",
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: p.row.remark == null ? "none" : "block",
                      },
                      domProps: {
                        title: "适用于: " + p.row.remark,
                      },
                    },
                    "适用于: " + p.row.remark
                  ),
                ]),
              ]
            );
          },
        },
        {
          title: "申请数",
          key: "alertNum",
          minWidth: 85,
          align: "center",
        },
        {
          title: "单位",
          key: "unit",
          minWidth: 65,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.unit;
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "单价/元",
          key: "unitPrice",
          minWidth: 85,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.unitPrice.toFixed(2);
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "小计",
          key: "unitPrice",
          minWidth: 65,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const Num = (row.unitPrice * row.alertNum).toFixed(2);
            const Num2 = (row.jdPrice * row.alertNum).toFixed(2);
            return (
              <span style={{ "font-size": "14px" }}>
                {this.customerId == 0 ? Num2 : Num}
              </span>
            );
          },
        },
      ],
      tableCols2: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "合同名称",
          key: "contractName",
          minWidth: 260,
          align: "left",
        },
        {
          title: "物资信息",
          minWidth: 250,
          key: "consumableIdsList",
          render: (h, params) => {
            return (
              <div>
                {params.row.consumableIdsList.map((item) => {
                  const budget = item.jdPrice;
                  const num = new Intl.NumberFormat("zh-CN", {
                    style: "currency",
                    currency: "CNY",
                  }).format(budget);
                  return (
                    <div>
                      {item.brand ? item.brand + "/" : ""}
                      {item.model}/{item.name}*{item.alertNum}
                      {item.unit}-<span style="color:blue">单价: {num}</span>元
                    </div>
                  );
                })}
              </div>
            );
          },
        },
        {
          title: "供应商",
          key: "supplierName",
          minWidth: 260,
          align: "left",
        },
        {
          title: "合同",
          minWidth: 80,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            if (row.fileUrl !== null) {
              return (
                <svg
                  onClick={() => {
                    this.handleRender(row.fileUrl);
                  }}
                  t="1686795127586"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="7800"
                  width="20"
                  height="20"
                >
                  <path
                    d="M848.8576 199.1936H415.7568c0-26.5728-21.5424-48.128-48.128-48.128H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128V343.5648c0 26.5984 21.5424 48.1408 48.128 48.1408h673.728c26.5728 0 48.128-21.5424 48.128-48.1408v-96.2432c-0.0128-26.5856-21.5552-48.128-48.1408-48.128z"
                    fill="#CCA352"
                    p-id="7801"
                  ></path>
                  <path
                    d="M800.7424 247.3088H223.2576c-26.5728 0-48.128 21.5424-48.128 48.128v48.128c0 26.5984 21.5424 48.1408 48.128 48.1408h577.472c26.5728 0 48.128-21.5424 48.128-48.1408v-48.128c0-26.5728-21.5424-48.128-48.1152-48.128z"
                    fill="#FFFFFF"
                    p-id="7802"
                  ></path>
                  <path
                    d="M848.8576 295.4368H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128v481.2544c0 26.5472 21.5424 48.128 48.128 48.128h673.728c26.5728 0 48.128-21.568 48.128-48.128V343.552c-0.0128-26.5728-21.5552-48.1152-48.1408-48.1152z"
                    fill="#FFCC66"
                    p-id="7803"
                  ></path>
                </svg>
              );
            } else {
              return;
            }
          },
        },
        {
          title: "金额",
          key: "contractMoney",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const budget = row.contractMoney;
            const num = new Intl.NumberFormat("zh-CN", {
              style: "currency",
              currency: "CNY",
            }).format(budget);
            return (
              <div>
                <p style={{ "font-size": "14px" }}>{num}</p>
              </div>
            );
          },
        },
        {
          title: "付款方式",
          minWidth: 150,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.payMethod === 1
                ? "对公协议发货"
                : row.payMethod === 2
                  ? "对公预付款"
                  : row.payMethod === 3
                    ? "对私预付款"
                    : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "付款状态",
          key: "payState",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.payState === 1 ? "已付款" : row.payState === 2 ? "未付款" : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        {
          title: "付款比例",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            return <span style={{ "font-size": "14px" }}>{row.payProportion}%</span>;
          },
        },
        {
          title: "开票状态",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text =
              row.invoiceState === 1 ? "已开票" : row.invoiceState === 2 ? "未开票" : "";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
      ],
    };
  },
  created() {
    if (this.customerId == 0) {
      let obj = {
        title: "单价",
        width: 110,
        align: "center",
        render: (h, params) => {
          const row = params.row.jdPrice ? params.row.jdPrice : 0;
          const text = row.toFixed(2);
          return <span>{text}</span>;
        },
      };
      this.tableCols1.splice(4, 1, obj);
    }
    let query = this.$route.query;
    if (query.kv) {
      this.kv = query.kv;
      this.initData(this.kv);
      this.ContractinitData(this.kv);
    }
    if (this.workId) {
      this.initData(this.workId);
    }
  },
  mounted() { },
  methods: {
    handleRender(text) {
      const texturl = text.split(",");
      for (let i = 0; i < texturl.length; i++) {
        texturl[i] = this.IMAGE_HOST + texturl[i];
      }
      let files = texturl.map((texturl) => {
        const parts = texturl.split("#");
        return {
          url: parts[0],
          name: parts[1],
        };
      });
      this.$Modal.success({
        closable: true,
        title: `查看附件`,
        width: "400px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <List border size="small">
                {files.map((item) => {
                  return (
                    <ListItem>
                      <a href={item.url} target="_blank">
                        {item.name}
                      </a>
                    </ListItem>
                  );
                })}
              </List>
            </div>
          );
        },
      });
    },
    ContractinitData(id) {
      // 加载详情工单数据
      let obj = {
        procurementId: id,
      };
      $utils.api.load(`/admin/system/procurementContract/list`, obj).then((res) => {
        if (res && res.rows) {
          let data = res.rows;
          this.data2 = data;
        }
      });
    },
    errorHandler() {
      return true;
    },
    initData(id) {
      // 加载详情工单数据
      $utils.api.load(`/admin/system/procurementWork/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.info = res.data;
          let data = res.data;
          this.maintainerName = data.maintainerName;
          this.endTotalPrice = data.endTotalPrice ? data.endTotalPrice.toFixed(2) : 0;
          this.shiyou = data.becauseWork;
          this.TrackingNum = data.logisticsTrackingNum;
          if (data.needTime) {
            var date = res.data.needTime;
            this.jiaofuData = date.split("T")[0];
          }
          this.shouhuoInfo = data.receivingInformation;
          let arr = data.sysProcurementDetails;
          let num = arr.reduce((total, item) => {
            return total + item.jdPrice * item.alertNum;
          }, 0);
          let num1 =
            data.userTotalPrice != null ? data.userTotalPrice.toFixed(2) : num.toFixed(2);
          let num2 = data.totalPrice ? data.totalPrice.toFixed(2) : 0;
          this.zongjia = this.customerId == 0 ? num1 : num2;
          if (data.state == 4 || data.state == 7) {
            this.tableCols1.push({
              title: "发货数",
              key: "shipmentQuantity",
              minWidth: 85,
              align: "center",
            });
          }
          if (data.state == 5) {
            this.tableCols1.push(
              {
                title: "发货数",
                key: "shipmentQuantity",
                minWidth: 85,
                align: "center",
              },
              {
                title: "收货数",
                key: "shipmentQuantity",
                minWidth: 85,
                align: "center",
              }
            );
          }
          if (data.receiveId != null) {
            this.getUserInfo(data.receiveId, 1); //申请人
          }
          if (data.examineId != null) {
            this.getUserInfo(data.examineId, 2); //审核人
          }
          if (data.procurementId != null) {
            this.getUserInfo(data.procurementId, 3); //采购人
          }
          for (let i = 0; i < arr.length; i++) {
            let consumableIn = {};
            consumableIn.consumableNum = arr[i].consumableNum;
            consumableIn.consumableImgUrl = arr[i].consumableImgUrl;
            consumableIn.brand = arr[i].brand;
            consumableIn.name = arr[i].name;
            consumableIn.model = arr[i].model;
            consumableIn.remark = arr[i].remark;
            consumableIn.num = arr[i].num;
            consumableIn.unit = arr[i].unit;
            consumableIn.alertNum = arr[i].alertNum;
            consumableIn.unitPrice = arr[i].unitPrice;
            consumableIn.jdPrice = arr[i].jdPrice;
            consumableIn.shipmentQuantity = arr[i].shipmentQuantity;
            this.data1.push(consumableIn);
          }
          this.handlingTime2 = this.computingTime(data.receiveTime, data.finishTime);
          this.id = data.id;
        }
      });
    },
    async getUserInfo(userId, num) {
      let res = await $utils.api.load(`/admin/system/user/get/${userId}`, {});
      if (res.data != null) {
        let src = res.data.avatar;
        if (num == 2) {
          this.info.examineImg = src;
        }
        if (num == 3) {
          this.info.procurementImg = src;
        }
        if (num == 1) {
          this.info.receiveImg = src;
        }
      }
    },
    //计算相差时间
    computingTime(a, b) {
      //a开始时间//b结束时间
      var date3 = new Date(b).getTime() - new Date(a).getTime(); //时间差的毫秒数
      //------------------------------
      //计算出相差天数
      // var days = Math.floor(date3 / (24 * 3600 * 1000));
      //计算出小时数
      var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
      var hours = Math.floor(leave1 / (3600 * 1000));
      //计算相差分钟数
      var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
      var minutes = Math.floor(leave2 / (60 * 1000));
      //计算相差秒数
      var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
      var seconds = Math.round(leave3 / 1000);
      return hours + "时" + minutes + "分" + seconds + "秒";
    },
  },
};
</script>
<style lang="less" scoped>
.bottom {
  margin-top: 20px;
  display: flex;
  justify-content: space-around;

  .Bleft {
    width: 68%;

    .zong {
      margin-top: 10px;
      text-align: right;
    }
  }

  .Bright {
    width: 30%;
  }
}

.consumableClass {
  text-indent: 60px;
}

.workOrder_info {
  width: 100%;
  background: #fff;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;

  .center {
    width: 50%;

    .elp {
      padding-top: 10px;
      position: fixed;
      top: 110px;
      color: #409eff;
    }

    .elp1 {
      left: 44.875rem;
    }

    .elp2 {
      left: 30.375rem;
    }
  }

  .right {
    color: #000;
    font-size: 13px;
    font-weight: 500;
  }
}

.workOrder_info2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  background: #fff;
  border-radius: 5px;
  position: relative;
  margin-bottom: 10px;
  padding-left: 18px;
  padding-right: 140px;
  /* .left {
    margin-left: 18px;
  }
  .right {
    position: absolute;
    right: 138px;
  } */
}

.workOrder_content {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  background: #fff;
  width: 100%;
  border-radius: 5px;

  .title {
    color: #000;
    font-size: 13px;
    font-weight: 600;
  }

  .item_box {
    display: flex;
  }
}

.workOrder_br {
  height: 1px;
  width: 100%;
  background: #f7f7f7;
}

.common_title {
  color: #000;
  font-size: 13px;
  font-weight: 500;
}

.common_image {
  width: 60px;
  height: 60px;
  border-radius: 2px;
  background: #f7f7f7;
}

.common_image_weixiu {
  width: 60px;
  height: 160px;
  border-radius: 2px;
  background: #fff;
  display: flex;
}

.common_color {
  color: #666;
}

.common_color1 {
  color: orange;
  padding-top: 10px;
}

.common_color2 {
  color: blue;
  padding-top: 10px;
}

.common_color3 {
  color: green;
  padding-top: 10px;
}

.common_color4 {
  color: red;
  padding-top: 10px;
}

.divider {
  margin: 0;
}
</style>
